import { Component, Input, OnInit } from '@angular/core';
import { arrayMoveImmutable } from 'array-move';
import { Globals } from 'projects/core/src/globals';
import { i, json } from 'mathjs';
import { TypesService } from '../../services/types.service';
import { CustomfieldsService } from 'projects/core/src/lib/customfields.service';

@Component({
  selector: 'app-fields',
  templateUrl: './fields.component.html',
  styleUrls: ['./fields.component.css']
})
export class FieldsComponent implements OnInit {

  @Input()
  sections:any=[];

  customfields:any=[];
  

  tabsection=0;
  id_section=0;
  param_selected="";

  colors:any=["Rosso","Giallo","Arancione","Verde",,"Blu","Indaco","Viola"];
  qualifications:any=["Nessuno","Licenza Elementare","Licenza Media","Diploma di Scuola Superiore","Laurea Triennale","Laurea Magistrale","Master Universitario"];
  months:any=["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"];
  italian_regions:any=["Piemonte","Valle d'Aosta","Lombardia"," Trentino-Alto Adige"," Veneto","Friuli-Venezia Giulia","Liguria","Emilia-Romagna","Toscana","Umbria","Marche","Lazio","Abruzzo","Molise","Campania","Puglia","Basilicata","Calabria","Sicilia","Sardegna"];
  italian_country:any=["Agrigento","Alessandria","Ancona","Aosta","Arezzo","Ascoli Piceno","Asti","Avellino","Bari","Barletta-Andria-Trani","Belluno","Benevento","Bergamo","Biella","Bologna","Bolzano","Brescia","Brindisi","Cagliari","Caltanissetta","Campobasso","Caserta","Catania","Catanzaro","Chieti","Como","Cosenza","Cremona","Crotone","Cuneo","Enna","Fermo","Ferrara","Firenze","Foggia","Forlì-Cesena","Frosinone","Genova","Gorizia","Grosseto","Imperia","Isernia","L’aquila","La spezia","Latina","Lecce","Lecco","Livorno","Lodi","Lucca","Macerata","Mantova","Massa-Carrara","Matera","Messina","Milano","Modena","Monza e Brianza","Napoli","Novara","Nuoro","Oristano","Padova","Palermo","Parma","Pavia","Perugia","Pesaro e Urbino","Pescara","Piacenza","Pisa","Pistoia","Pordenone","Potenza","Prato","Ragusa","Ravenna","Reggio Calabria","Reggio Emilia","Rieti","Rimini","Roma","Rovigo","Salerno","Sassari","Savona","Siena","Siracusa","Sondrio","Sud Sardegna","Taranto","Teramo","Terni","Torino","Trapani","Trento","Treviso","Trieste","Udine","Varese","Venezia","Verbano-Cusio-Ossola","Vercelli","Verona","Vibo valentia","Vicenza","Viterbo"];
  nations:any=["Andorra","Emirati Arabi Uniti","Afghanistan","Antigua e Barbuda","Anguilla","Albania","Armenia","Antille Olandesi","Angola","Antartide","Argentina","Samoa americane","Austria","Australia","Aruba","Azerbaigian","Bosnia ed Erzegovina","Barbados","Bangladesh","Belgio","Burkina Faso","Bulgaria","Bahrein","Burundi","Benin","Bermuda","Brunei","Bolivia","Brasile","Bahamas","Bhutan","Isola Bouvet","Botswana","Bielorussia","Belize","Canada","Isole Cocos (Keeling)","Congo (RDC)","Repubblica Centrafricana","Congo (Repubblica)","Svizzera","Costa d'Avorio","Isole Cook","Cile","Camerun","Cina","Colombia","Costa Rica","Cuba","Capo Verde","Isola Christmas","Cipro","Repubblica Ceca","Germania","Gibuti","Danimarca","Dominica","Repubblica Dominicana","Algeria","Ecuador","Estonia","Egitto","Sahara occidentale","Eritrea","Spagna","Etiopia","Finlandia","Figi","Isole Falkland (Isole Malvine)","Micronesia","Isole Fær Øer","Francia","Gabon","Regno Unito","Grenada","Georgia","Guyana francese","Guernsey","Ghana","Gibilterra","Groenlandia","Gambia","Guinea","Guadalupa","Guinea Equatoriale","Grecia","Georgia del Sud e Sandwich Australi","Guatemala","Guam","Guinea-Bissau","Guyana","Striscia di Gaza","Hong Kong","Isole Heard e McDonald","Honduras","Croazia","Haiti","Ungheria","Indonesia","Irlanda","Israele","Isola di Man","India","Territorio britannico dell'Oceano Indiano","Iraq","Iran","Islanda","Italia","Jersey","Giamaica","Giordania","Giappone","Kenya","Kirghizistan","Cambogia","Kiribati","Comore","Saint Kitts e Nevis","Corea del Nord","Corea del Sud","Kuwait","Isole Cayman","Kazakistan","Laos","Libano","Saint Lucia","Liechtenstein","Sri Lanka","Liberia","Lesotho","Lituania","Lussemburgo","Lettonia","Libia","Marocco","Monaco","Moldavia","Montenegro","Madagascar","Isole Marshall","Macedonia del Nord","Mali","Myanmar","Mongolia","Macao","Isole Marianne settentrionali","Martinica","Mauritania","Montserrat","Malta","Mauritius","Maldive","Malawi","Messico","Malaysia","Mozambico","Namibia","Nuova Caledonia","Niger","Isola Norfolk","Nigeria","Nicaragua","Paesi Bassi","Norvegia","Nepal","Nauru","Niue","Nuova Zelanda","Oman","Panama","Perù","Polinesia francese","Papua Nuova Guinea","Filippine","Pakistan","Polonia","Saint-Pierre e Miquelon","Isole Pitcairn","Portorico","Territori palestinesi","Portogallo","Palau","Paraguay","Qatar","Riunione","Romania","Serbia","Russia","Ruanda","Arabia Saudita","Isole Salomone","Seychelles","Sudan","Svezia","Singapore","Sant'Elena","Slovenia","Svalbard e Jan Mayen","Slovacchia","Sierra Leone","San Marino","Senegal","Somalia","Suriname","São Tomé e Príncipe","El Salvador","Siria","Swaziland","Isole Turks e Caicos","Ciad","Terre australi francesi","Togo","Thailandia","Tagikistan","Tokelau","Timor Est","Turkmenistan","Tunisia","Tonga","Turchia","Trinidad e Tobago","Tuvalu","Taiwan","Tanzania","Ucraina","Uganda","Altre isole americane del Pacifico","Stati Uniti","Uruguay","Uzbekistan","Città del Vaticano","Saint Vincent e Grenadine","Venezuela","Isole Vergini Britanniche","Isole Vergini Americane","Vietnam","Vanuatu","Wallis e Futuna","Samoa","Kosovo","Yemen","Mayotte","Sudafrica","Zambia","Zimbabwe"];

  default_file_params=[
    {"name":"subdirectory","value":"","label":"Nome della sottocartella (da creare)","type":"text","description":"utilizzare le keyword {{nome campo}} per sostituire i campi del record"},
    {"name":"default_filename","value":"","label":"Nome del file (predefinito)","type":"text","description":"utilizzare le keyword {{nome campo}} per sostituire i campi del record, oppure [filename] per inserire il nome del file che si sta caricando"},
    {"name":"multiple","value":"false","label":"Permetti di aggiungere più file","type":"boolean"}    
  ];

  default_photo_params=[
    {"name":"multiple","value":"false","label":"Permetti di aggiungere più foto","type":"boolean"}    
  ];

  default_addresses_params=[
    {"name":"id_type","value":"","label":"ID della tipologia di default","type":"text"}    
  ];

  type_addresses=[];
  constructor(private typesService:TypesService,private customfieldsService:CustomfieldsService) { }


  ngOnInit(): void {
    this.customfieldsService.getCustomFields("",true).subscribe((result)=>{
      this.customfields=result;
    });
    this.typesService.getTypes("addresses").subscribe((result)=>{
      this.type_addresses=result;
    });    
    
  }


  ngOnChanges(){
    
    if(this.sections){
      if(!this.isArray(this.sections)){
        try{
        this.sections=JSON.parse(this.sections)        
        }catch{
          this.sections=[]
        }
      }

      this.sections.sort(function (a: any, b: any) {
          return a.id - b.id;
      })

      for(let s of this.sections){
        for(let f of s.fields)
          this.suggestParams(f);
      }

    }

  }


  addField(){
    
    let f={};
    f['id_parent']=this.sections[this.tabsection].id;

    if(this.sections[this.tabsection].fields==null || this.sections[this.tabsection].fields == undefined){
      this.sections[this.tabsection].fields=[];
    }
    this.sections[this.tabsection].fields.push(f);

  }


  moveField(field,direction="up"){

    for(let i=0;i<this.sections[this.tabsection].fields.length;i++){
     
      if(field==this.sections[this.tabsection].fields[i]){
        if(direction=="up"){
          if(i>0)
            this.sections[this.tabsection].fields = arrayMoveImmutable(this.sections[this.tabsection].fields, i, i-1);
            
        }
        else
          if(i<this.sections[this.tabsection].fields.length-1)
            this.sections[this.tabsection].fields = arrayMoveImmutable(this.sections[this.tabsection].fields, i, i+1);
        
        return;
      }
      
    }

  }


  removeField(field){
    for(let i=0;i<this.sections[this.tabsection].fields.length;i++){
     
      if(field==this.sections[this.tabsection].fields[i]){
        this.sections[this.tabsection].fields.splice(i,1);
        return;
      }
    }
  }


  duplicateField(field){
    let new_field={};
    Object.assign(new_field,field);
    new_field['id']=0;
    this.sections[this.tabsection].fields.push(new_field);
  }


  array_move(arr, old_index, new_index) {
    while (old_index < 0) {
        old_index += arr.length;
    }
    while (new_index < 0) {
        new_index += arr.length;
    }
    if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing purposes
  }
  
  
  addSection(){
    if(!this.sections){
      this.sections=[];
    }

    if(this.sections.length>0){
      if(!this.sections[this.tabsection].fields){
        this.sections[this.tabsection].fields=[];
      }
    }
    
    let name_section=prompt("Inserisci il nome della sezione","");

    let s={};
    s['id']=0;
    s['type']="section";
    s['name']=name_section;
    s['label']=name_section;
    s['fields']=[];
   
    
    
    this.sections.push(s);
    

  }


  removeSection(s){

    Globals.modal.showConfirm("","Confermi di voler eliminare la sezione?",()=>{  
      const index: number = this.sections.indexOf(s);
      this.sections.splice(index,1);     
    },"Sì. Elimina","No. Annulla","danger");

  }


  moveToSection(r){
    //aggiungi il campo alla nuova sezione
    for(let section of this.sections){
      if(section.id==r.id_parent){
        section.fields.push(r);
      }
    }

    //togli il campo dalla vecchia sezione
    for(let section of this.sections){
      for(let i=0;i<section.fields.length;i++){
        if(section.fields[i]==r && section.id!=r.id_parent){
          section.fields.splice(i,1);
          return;
        }
      }
    }
  }


  suggestParams(field){
    switch(field.type){
      case "select":
        if(field.params=="" || field.params==null || field.params==undefined)
          field.params=[];
        else
          field.params=JSON.parse(field.params)
        break;
      case "file":
        if(field.params=="" || field.params==null || field.params==undefined)
          field.params=this.default_file_params;
        else
          field.params=JSON.parse(field.params);
        break;
      case "photo":
        if(field.params=="" || field.params==null || field.params==undefined)
          field.params= this.default_photo_params;
        else
          field.params=JSON.parse(field.params);
        break;

      case "address":
        if(field.params=="" || field.params==null || field.params==undefined)
          field.params=this.default_addresses_params;
        else
          field.params=JSON.parse(field.params);
        break;

      case "table":
        if(field.params=="" || field.params==null || field.params==undefined)
          field.params=[];
        else
          try{
       
            if(!Array.isArray(field.params))
              field.params=JSON.parse(field.params);
            
          }catch{
            field.params=[];
          }
        break;
      default:
        if(field.params=="" || field.params==null || field.params==undefined)
          field.params= [];
        break;
    }
  }

  deleteSection(section){
    console.log(this.sections);
    Globals.modal.showConfirm("","Confermi di voler eliminare la sezione e tutti i campi collegati?",()=>{        
      for(let i=0;i<this.sections.length;i++){
        if(this.sections[i]==section){
          this.sections.splice(i,1);
          return;
        }
      }
    },"Sì, elimina","No. Annulla","danger");
  }


  renameSection(section){
    // let name=prompt("Indicare il nome della sezione",section.name);
    // if(name!="")
    //   section.name=name;
    //   section.label=name;

    section.name=section.label;
    if(section.name=="")
      section.name='sez'+section.id
    section.name=section.name.replaceAll('.','_').replaceAll(' ','_');

  }

  renameField(field){
    field.name=field.label;
    if(field.name=="")
      field.name='field'+field.id
    field.name=field.name.replaceAll('.','_').replaceAll(' ','_');
  }


  addValueToParams(field){
   
    if(!field.params){
      field.params=[];
    }else{
      try{
        if(typeof(field.params)=="string")
          field.params=JSON.parse(field.params);
      }catch{
        field.params=[];
      }
      
    }
    let value=prompt("Indicare il valore dell'elemento","");
    if(value){
      field.params.push(value);
    }
  }


  removeValueFromParams(field){
    if(!field.params){
      field.params=[];
    }else{
      if(typeof(field.params)=="string")
        field.params=field.params.split(";");
    }

    for(let i=0;i<field.params.length;i++){
      if(field.params[i]==this.param_selected){
        field.params.splice(i,1);
        this.param_selected="";
        return;
      }
    }
  }


  addAddressesParams(field,name,event){
    console.log(event);
    console.log(event.target);
  }


  getAddressParam(field,name){

  }


  isArray(obj){
    return Array.isArray(obj);
  }


  typeCode(t) {
    return '{{'+t+'}}'
  }

}
